module.exports = __webpack_public_path__ + "static/img/design-5.08cb7b97.png";